import { useTranslation } from 'react-i18next'

import { FileUploadPlaceholder } from '../../../../../../File'
import { ICON_HEIGHT_24 } from '../../../../../../Icon'
import { QA_NAME_LISTING_PHOTO_MOSAIC_ADD } from '../RentalPortalListingPhotoMosaic.constants'

import * as styles from './RentalPortalListingPhotoMosaicAddTile.module.css'

import PlusIcon from '../../../../../../../icons/plus.svg'

function RentalPortalListingPhotoMosaicAddTile({ isWide, onClick }) {
  const { t } = useTranslation()

  return (
    <FileUploadPlaceholder
      Icon={PlusIcon}
      className={
        isWide ? styles.wide : styles.RentalPortalListingPhotoMosaicAddTile
      }
      iconSize={ICON_HEIGHT_24}
      qaName={QA_NAME_LISTING_PHOTO_MOSAIC_ADD}
      text={t('RentalPortal.ListingProfileAddPhotosKey')}
      onClick={onClick}
    />
  )
}

export default RentalPortalListingPhotoMosaicAddTile
